import Login from '../Login';
import {
  RedirectProps,
  RouteComponentProps,
  useParams,
} from 'react-router-dom';
import { PatientRouteParams } from '../router';

interface Props
  extends RouteComponentProps<
    PatientRouteParams,
    Exclude<RouteComponentProps['staticContext'], undefined>,
    { from: RedirectProps['to'] }
  > {}

export const AppointmentLogin: React.FC<Props> = (props) => {
  const { authenticationCode } = useParams<{ authenticationCode: string }>();
  return (
    <Login overrideRedirectUrl={`/confirm/${authenticationCode}`} {...props} />
  );
};
